module.exports = __webpack_public_path__ + "static/media/after.5c2f4279.png";